export default "__VITE_ASSET__CtItctk8__"